import type { SVGProps } from 'react';

const SvgImages = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="images">
      <path d="M31.42 3.39A2.75 2.75 0 0 0 28.67.64H3.33A2.75 2.75 0 0 0 .58 3.39v25.22a2.75 2.75 0 0 0 2.75 2.75h25.34a2.75 2.75 0 0 0 2.75-2.75ZM3.33 2.14h25.34a1.25 1.25 0 0 1 1.25 1.25V20.3l-7-7.19a2.75 2.75 0 0 0-3.85-.11l-5.6 5.26L10.54 16a2.74 2.74 0 0 0-3.54.09l-4.9 4.45V3.39a1.25 1.25 0 0 1 1.23-1.25M2.14 29a1.3 1.3 0 0 1-.06-.35v-6L8 17.2a1.26 1.26 0 0 1 1.62-.06l2.76 2.19Zm26.53.9H3.37l16.72-15.78a1.26 1.26 0 0 1 1.76 0l8.07 8.29v6.16a1.25 1.25 0 0 1-1.25 1.29Z" />
      <path d="M13.26 12.72a4 4 0 1 0-4-4 4 4 0 0 0 4 4m0-6.51a2.51 2.51 0 1 1-2.51 2.51 2.51 2.51 0 0 1 2.51-2.51" />
    </g>
  </svg>
);

export default SvgImages;
